<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.goods_name"
            placeholder="请输入奖品名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.goods_type"
            placeholder="请选择赏品类型"
            style="width: 180px; margin-right: 10px"
            clearable
          >
            <el-option label="真实赏品" :value="1" />
            <el-option label="虚拟赏品" :value="2" />
          </el-select>

          <el-select
            v-model.number="searchParams.type"
            placeholder="请选择类型"
            style="width: 180px; margin-right: 10px"
            clearable
          >
            <el-option label="进阶实物" :value="1" />
            <el-option label="进阶卡片" :value="2" />
          </el-select>

          <el-select
            v-model.number="searchParams.level_id"
            placeholder="请选择等级"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in levelList"
              :key="item.level_id"
              :label="item.name"
              :value="item.level_id"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加奖品</el-button
          >
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="奖品名称" prop="goods_name" min-width="200" />
          <el-table-column label="奖品图片" width="120" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.goods_image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="赏品类型" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
            </template>
          </el-table-column>
          <el-table-column
            label="类型"
            prop="type_name"
            width="120"
            align="center"
          />
          <el-table-column
            label="等级"
            prop="level_name"
            width="100"
            align="center"
          />
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
          />
          <el-table-column
            label="兑换价格"
            prop="recovery_price"
            width="100"
            align="center"
          />
          <el-table-column
            label="亏损价"
            prop="loss_price"
            width="100"
            align="center"
          />
          <!-- 只改这里：库存 → 兑换数量 -->
          <el-table-column
            label="兑换数量"
            prop="num"
            width="100"
            align="center"
          />
          <el-table-column
            label="库存数量"
            prop="origin_num"
            width="100"
            align="center"
          />
          <!-- 状态列 宽度180 上架/下架 -->
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />

          <!-- 操作列 固定右侧 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handleDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="奖品详情"
          :visible.sync="pcShowCard"
          width="500px"
          center
          close-on-click-modal
          append-to-body
        >
          <div class="goods-card" v-if="pcCurrentRow">
            <div class="goods-img">
              <img :src="pcCurrentRow.goods_image" alt="图片" />
            </div>
            <div class="goods-info">
              <p>
                <label>ID：</label><span>{{ pcCurrentRow.id }}</span>
              </p>
              <p>
                <label>名称：</label><span>{{ pcCurrentRow.goods_name }}</span>
              </p>
              <p>
                <label>赏品类型：</label
                ><span>{{
                  pcCurrentRow.goods_type == 1 ? "真实赏品" : "虚拟赏品"
                }}</span>
              </p>
              <p>
                <label>类型：</label><span>{{ pcCurrentRow.type_name }}</span>
              </p>
              <p>
                <label>等级：</label><span>{{ pcCurrentRow.level_name }}</span>
              </p>
              <p>
                <label>价格：</label><span>{{ pcCurrentRow.price }}</span>
              </p>
              <p>
                <label>兑换价格：</label
                ><span>{{ pcCurrentRow.recovery_price }}</span>
              </p>
              <p>
                <label>亏损价：</label
                ><span>{{ pcCurrentRow.loss_price }}</span>
              </p>
              <!-- 只改这里：库存 → 兑换数量 -->
              <p>
                <label>兑换数量：</label><span>{{ pcCurrentRow.num }}</span>
              </p>
              <p>
                <label>库存数量：</label
                ><span>{{ pcCurrentRow.origin_num }}</span>
              </p>
            </div>
          </div>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加奖品' : '编辑奖品'"
          :visible.sync="pcDialogVisible"
          width="600px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="选择商品" prop="goods_id">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenGoodsDialog"
                  >选择商品</el-button
                >
                <div
                  v-if="pcForm.goods_image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="pcForm.goods_image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="赏品类型" prop="goods_type">
              <el-select
                v-model.number="pcForm.goods_type"
                placeholder="请选择"
                style="width: 300px"
              >
                <el-option label="真实赏品" :value="1" />
                <el-option label="虚拟赏品" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model.number="pcForm.type"
                placeholder="请选择"
                style="width: 300px"
              >
                <el-option label="进阶实物" :value="1" />
                <el-option label="进阶卡片" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="等级" prop="level_id">
              <el-select
                v-model.number="pcForm.level_id"
                placeholder="请选择等级"
                style="width: 300px"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="pcForm.price"
                placeholder="请输入价格"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="兑换价格" prop="recovery_price">
              <el-input
                v-model="pcForm.recovery_price"
                placeholder="请输入兑换价格"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="亏损价格" prop="loss_price">
              <el-input
                v-model="pcForm.loss_price"
                placeholder="请输入亏损价格"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="库存数量" prop="num">
              <el-input
                v-model="pcForm.num"
                placeholder="请输入库存数量"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 商品选择弹窗 -->
        <el-dialog
          title="选择商品"
          :visible.sync="pcGoodsDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="goodsLoading"
            element-loading-text="加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-input
                v-model="pcGoodsSearch.title"
                placeholder="商品名称"
                clearable
                style="width: 220px"
              />
              <el-select
                v-model.number="pcGoodsSearch.type"
                placeholder="商品分类"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in goodsLevelList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-select
                v-model.number="pcGoodsSearch.level_id"
                placeholder="商品等级"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in currentGoodsLevelItems"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="goods in goodsList"
                :key="goods.id"
                @click="pcSelectGoods(goods)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedGoodsId === goods.id
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedGoodsId === goods.id ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="goods.image"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ goods.title }}
                </span>
              </div>
            </div>

            <el-pagination
              @size-change="handleGoodsSizeChange"
              @current-change="handleGoodsCurrentChange"
              :current-page="pcGoodsSearch.page"
              :page-size="pcGoodsSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="goodsTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcGoodsDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectGoods"
              >确认选择</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.goods_name"
            placeholder="奖品名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.goods_type"
              placeholder="赏品类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option label="真实赏品" :value="1" />
              <el-option label="虚拟赏品" :value="2" />
            </el-select>
            <el-select
              v-model.number="searchParams.type"
              placeholder="类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option label="进阶实物" :value="1" />
              <el-option label="进阶卡片" :value="2" />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.level_id"
              placeholder="等级"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in levelList"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <img :src="item.goods_image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.goods_name }}</div>
                <div class="meta">
                  ID:{{ item.id }} |
                  {{ item.goods_type == 1 ? "真实" : "虚拟" }} |
                  {{ item.type_name }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>价格：¥{{ item.price }}</div>
              <div>兑换：¥{{ item.recovery_price }}</div>
              <!-- 只改这里：库存 → 兑换数量 -->
              <div>兑换数量：{{ item.num }}</div>
              <div>库存数量：{{ item.origin_num }}</div>
              <div>等级：{{ item.level_name }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDel(item)"
                >删除</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情 -->
        <el-dialog
          title="奖品详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileCurrentRow.goods_image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{
                mobileCurrentRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="奖品名称">{{
                mobileCurrentRow.goods_name
              }}</el-descriptions-item>
              <el-descriptions-item label="赏品类型">{{
                mobileCurrentRow.goods_type == 1 ? "真实赏品" : "虚拟赏品"
              }}</el-descriptions-item>
              <el-descriptions-item label="类型">{{
                mobileCurrentRow.type_name
              }}</el-descriptions-item>
              <el-descriptions-item label="等级">{{
                mobileCurrentRow.level_name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileCurrentRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="兑换价"
                >¥{{ mobileCurrentRow.recovery_price }}</el-descriptions-item
              >
              <el-descriptions-item label="亏损价"
                >¥{{ mobileCurrentRow.loss_price }}</el-descriptions-item
              >
              <!-- 只改这里：库存 → 兑换数量 -->
              <el-descriptions-item label="兑换数量">{{
                mobileCurrentRow.num
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileCurrentRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileCurrentRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加奖品' : '编辑奖品'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="选择商品">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenGoodsDialog"
                  >选择商品</el-button
                >
                <div
                  v-if="mobileForm.goods_image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileForm.goods_image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="赏品类型" prop="goods_type">
              <el-select v-model.number="mobileForm.goods_type" size="medium">
                <el-option label="真实赏品" :value="1" />
                <el-option label="虚拟赏品" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select v-model.number="mobileForm.type" size="medium">
                <el-option label="进阶实物" :value="1" />
                <el-option label="进阶卡片" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="等级" prop="level_id">
              <el-select v-model.number="mobileForm.level_id" size="medium">
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="兑换价" prop="recovery_price">
              <el-input
                v-model="mobileForm.recovery_price"
                placeholder="兑换价"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="亏损价" prop="loss_price">
              <el-input
                v-model="mobileForm.loss_price"
                placeholder="亏损价"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="库存数量" prop="num">
              <el-input
                v-model.number="mobileForm.num"
                placeholder="库存数量"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端商品选择弹窗 -->
        <el-dialog
          title="选择商品"
          :visible.sync="mobileGoodsDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="goodsLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-input
                v-model="mobileGoodsSearch.title"
                placeholder="名称"
                size="mini"
                clearable
                style="flex: 1"
              />
              <el-select
                v-model.number="mobileGoodsSearch.type"
                placeholder="分类"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in goodsLevelList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </div>
            <div style="margin-bottom: 10px">
              <el-select
                v-model.number="mobileGoodsSearch.level_id"
                placeholder="等级"
                size="mini"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in currentGoodsLevelItems"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </div>
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-button size="mini" type="primary" @click="getGoodsList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetGoodsSearch">重置</el-button>
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="goods in goodsList"
                :key="goods.id"
                @click="mobileSelectGoods(goods)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedGoodsId === goods.id
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedGoodsId === goods.id
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="goods.image"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                  >{{ goods.title }}</span
                >
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleGoodsSizeChange"
                @current-change="handleGoodsCurrentChange"
                :current-page="mobileGoodsSearch.page"
                :page-size="mobileGoodsSearch.page_size"
                layout="prev, pager, next"
                :total="goodsTotal"
            pager-count="2"
            small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileGoodsDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="mobileConfirmSelectGoods"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "FusionPrize",
  data() {
    return {
      loading: false,
      tableData: [],
      levelList: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        goods_name: "",
        goods_type: "",
        type: "",
        level_id: "",
      },
      addRules: {
        goods_id: [
          { required: true, message: "请选择商品", trigger: "change" },
        ],
        goods_type: [
          { required: true, message: "请选择赏品类型", trigger: "change" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        level_id: [
          { required: true, message: "请选择等级", trigger: "change" },
        ],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        recovery_price: [
          { required: true, message: "请输入兑换价格", trigger: "blur" },
        ],
        loss_price: [
          { required: true, message: "请输入亏损价格", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入库存数量", trigger: "blur" }],
      },

      // 商品选择公共
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsLevelList: [],
      currentGoodsLevelItems: [],

      // PC
      pcShowCard: false,
      pcCurrentRow: null,
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        loss_price: "",
        num: "", // 改为字符串
      },
      pcGoodsDialogVisible: false,
      pcGoodsSearch: {
        page: 1,
        page_size: 12,
        title: "",
        type: "",
        level_id: "",
        flag: 7,
      },
      pcSelectedGoodsId: "",

      // 移动端
      mobileShowCard: false,
      mobileCurrentRow: null,
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        loss_price: "",
        num: "", // 改为字符串
      },
      mobileGoodsDialogVisible: false,
      mobileGoodsSearch: {
        page: 1,
        page_size: 12,
        title: "",
        type: "",
        level_id: "",
        flag: 7,
      },
      mobileSelectedGoodsId: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 融合奖品列表
    getList() {
      this.loading = true;
      api.fusionPrize
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.levelList = res.data.data.level || [];
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 状态切换
    handleStatus(row) {
      const old = row.status;
      this.loading = true;
      api.fusionPrize
        .status({
          prize_id: row.id,
          status: row.status,
        })
        .catch(() => {
          row.status = old;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 删除
    handleDel(row) {
      this.$confirm("确定要删除该奖品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.fusionPrize.del({ prize_id: row.id }).then((res) => {
          if (res.data.code == 1000) {
            this.getList();
          }
        });
      });
    },

    // 获取商品列表（选择商品）
    getGoodsList() {
      this.goodsLoading = true;
      api.goods
        .index({ params: this.pcGoodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.goodsList = res.data.data.data || [];
            this.goodsTotal = res.data.data.total || 0;
            this.goodsLevelList = res.data.data.goods_level || [];
          }
        })
        .finally(() => {
          this.goodsLoading = false;
        });
    },
    handleGoodsTypeChange(type) {
      this.pcGoodsSearch.level_id = "";
      this.mobileGoodsSearch.level_id = "";
      const find = this.goodsLevelList.find((item) => item.type == type);
      this.currentGoodsLevelItems = find ? find.goods_level : [];
    },
    resetGoodsSearch() {
      this.pcGoodsSearch = {
        page: 1,
        page_size: 12,
        title: "",
        type: "",
        level_id: "",
        flag: 7,
      };
      this.mobileGoodsSearch = {
        page: 1,
        page_size: 12,
        title: "",
        type: "",
        level_id: "",
        flag: 7,
      };
      this.currentGoodsLevelItems = [];
      this.getGoodsList();
    },
    handleGoodsSizeChange(val) {
      this.pcGoodsSearch.page_size = val;
      this.mobileGoodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.pcGoodsSearch.page = val;
      this.mobileGoodsSearch.page = val;
      this.getGoodsList();
    },

    // ==================== PC ====================
    handlePcRowClick(row) {
      this.pcCurrentRow = row;
      this.pcShowCard = true;
    },
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        goods_image: row.goods_image,
        goods_type: row.goods_type,
        type: row.type,
        level_id: row.level_id,
        price: row.price,
        recovery_price: row.recovery_price,
        loss_price: row.loss_price,
        // 编辑时表单回显 origin_num
        num: String(row.origin_num),
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        loss_price: "",
        num: "", // 字符串
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn =
          this.pcDialogType == "add"
            ? api.fusionPrize.add
            : api.fusionPrize.edit;
        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    pcOpenGoodsDialog() {
      this.pcGoodsDialogVisible = true;
      this.pcSelectedGoodsId = "";
      this.getGoodsList();
    },
    pcSelectGoods(goods) {
      this.pcSelectedGoodsId = goods.id;
    },
    pcConfirmSelectGoods() {
      if (!this.pcSelectedGoodsId) {
        this.$message.warning("请先选择商品");
        return;
      }
      const goods = this.goodsList.find(
        (item) => item.id === this.pcSelectedGoodsId
      );
      this.pcForm.goods_id = goods.id;
      this.pcForm.goods_image = goods.image;
      this.pcGoodsDialogVisible = false;
    },

    // ==================== 移动端 ====================
    handleMobileRowClick(row) {
      this.mobileCurrentRow = row;
      this.mobileShowCard = true;
    },
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        goods_image: row.goods_image,
        goods_type: row.goods_type,
        type: row.type,
        level_id: row.level_id,
        price: row.price,
        recovery_price: row.recovery_price,
        loss_price: row.loss_price,
        // 编辑时表单回显 origin_num
        num: String(row.origin_num),
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = {
        prize_id: "",
        goods_id: "",
        goods_image: "",
        goods_type: "",
        type: "",
        level_id: "",
        price: "",
        recovery_price: "",
        loss_price: "",
        num: "", // 字符串
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn =
          this.mobileDialogType == "add"
            ? api.fusionPrize.add
            : api.fusionPrize.edit;
        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mobileOpenGoodsDialog() {
      this.mobileGoodsDialogVisible = true;
      this.mobileSelectedGoodsId = "";
      this.getGoodsList();
    },
    mobileSelectGoods(goods) {
      this.mobileSelectedGoodsId = goods.id;
    },
    mobileConfirmSelectGoods() {
      if (!this.mobileSelectedGoodsId) {
        this.$message.warning("请先选择商品");
        return;
      }
      const goods = this.goodsList.find(
        (item) => item.id === this.mobileSelectedGoodsId
      );
      this.mobileForm.goods_id = goods.id;
      this.mobileForm.goods_image = goods.image;
      this.mobileGoodsDialogVisible = false;
    },

    // ==================== 公共 ====================
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        goods_name: "",
        goods_type: "",
        type: "",
        level_id: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px;
}
.goods-img img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}
.goods-info {
  flex: 1;
  font-size: 14px;
}
.goods-info p {
  margin: 10px 0;
  line-height: 1.6;
}
.goods-info label {
  font-weight: bold;
  width: 90px;
  display: inline-block;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/fusionPrize/index.vue